export default __webpack_public_path__ + "static/media/build_image.0b460afa.png";